import type { FC } from 'react';

import type { IconProps } from './types';

const TickCircle: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024" {...props}>
    <path
      fill={color}
      d="M512 85.333c-235.093 0-426.667 191.573-426.667 426.667s191.573 426.667 426.667 426.667 426.667-191.573 426.667-426.667-191.573-426.667-426.667-426.667zM715.947 413.867l-241.92 241.92c-5.789 5.782-13.784 9.359-22.613 9.359s-16.824-3.576-22.614-9.359v0l-120.747-120.747c-5.742-5.808-9.289-13.796-9.289-22.613s3.547-16.805 9.292-22.616l-0.003 0.003c12.373-12.373 32.853-12.373 45.227 0l98.133 98.133 219.307-219.307c12.373-12.373 32.853-12.373 45.227 0s12.373 32.427 0 45.227z"
    />
  </svg>
);

export default TickCircle;
